module.exports = __webpack_public_path__ + "img/bx-lesson-nickname-active.daf3c584.svg";